import Vue from 'vue';
import axios from 'axios';
import Login from '@/components/login/Login';
import FirstLogin from '@/components/login/FirstLogin';
import ForgotPassword from '@/components/login/ForgotPassword';
import RecoverPassword from '@/components/login/RecoverPassword';
import NexusEmail from '@/components/login/NexusEmail';
import VerificationCode from '@/components/login/VerificationCode';
import Customers from '@/components/customer/Index';
import CustomerShow from '@/components/customer/Detail';
import ValidateCustomerName from '@/components/customer/validateNames/Index';
import ReportCallCenter from '@/components/reports/call_center/Index';
// import ReportCallCenter from '@/components/reports/call_center/Index';
// import Templates from '@/components/templateV2/Index';
import NotificationSchedule from '@/components/notification_schedule/Index';
// import NotificationScheduleReport from '@/components/reports/notification_schedules/Index';
import BotWorkflowV2 from '@/components/templateV2/BotWorkflow';
import CompanyEmails from '@/components/company_email/Index';
import User from '@/components/user/Index';
import Panel from '@/components/panel/Index';
import PanelV2 from '@/components/panelV2/Index';
import Campaign from '@/components/campaign/Index';
import CampaignConfirm from '@/components/campaign/CampaignConfirm';
import CampaignResend from '@/components/campaign/CampaignResend';
import CampaignDetail from '@/components/campaign/CampaignDetail';
import CampaignAssigned from '@/components/campaign/CampaignAssigned';
import ChatCenter from '@/components/chat_center/Index';
import ChatCenterV2 from '@/components/chat_center_v2/Index';
import ChatCenterV2Panel from '@/components/chat_center_v2/Panel';
import ChatCenterReportV2 from '@/components//chat_center_v2/dashboard/Index';
import ChatCenterConfig from '@/components/chat_center/Config';
import ChatCategories from '@/components/chat_category/Index';
import InvalidData from '@/components/invalid_data/Index';
import AnswerTemplate from '@/components/answer_template/Index';
import WorkflowNotification from '@/components/workflow_notification/Index';
import WorkflowStages from '@/components/workflow_notification/WorkflowStages';
import WorkflowChannel from '@/components/workflow_channel/Index';
// import CallCenterDialer from '@/components/call_center/Index';
// import CallCenterSingle from '@/components/call_center/Single';
import ReportDownload from '@/components/report_download/Index';
import Domain from '@/components/domain/Index';
import BotV4Index from '@/components/bot_v4/Index';
import BotV4Flow from '@/components/bot_v4/Detail/Index';
import IvrV4Index from '@/components/ivr_v2/Index';
import IvrV4Flow from '@/components/ivr_v2/Detail/Index';
import Consumption from '@/components/reports/consumption/Index';
import ProductReport from '@/components/reports/product/Index';
import Maintenance from '@/components/maintenance/FirstMaintenanceIndex';
import Templates from '@/components/templateV2/Index';
import Homologations from '@/components/homologation/Index';
import CollectWorkflows from '@/components/CollectWorkflows/Index';
import CollectWorkflow from '@/components/CollectWorkflows/Detail/Index';
import V2CollectWorkflows from '@/components/V2CollectWorkflows/Index';
import V3CollectWorkflows from '@/components/V2CollectWorkflows/IndexV2';
import V2CollectWorkflow from '@/components/V2CollectWorkflows/Detail/Index';
import V3CollectWorkflow from '@/components/V2CollectWorkflows/Detail/IndexV2';
import ReportLoad from '@/components/reports/load/Index';
import ReportCustomer from '@/components/reports/customer/Index';
// import ReportNotificationSchedule from '@/components/reports/notification_schedule/Index';
import ReportNotificationSchedules from '@/components/reports/notification_schedules/Index';
import ChatCenterV2Config from '@/components/chat_center_v2/config/Index';
import Segmentation from '@/components/reports/segmentation/Index';
import ContainmentStates from '@/components/containment_states/Index';
import SelfService from '@/components/SelfService/Index';
import CallList from '@/components/CallList/Index';
import ConnectCampaign from '@/components/CallList/ConnectCampaign';
import CallListDetail from '@/components/CallList/Detail/Index';
import CallListWait from '@/components/CallList/Wait';
import CallCenterWaitV2 from '@/components/CallCenter/WaitV2';
import CallCenterUsers from '@/components/CallCenter/Users';
import NumxCallCenterAlgorithm from '@/components/Numx/CallCenterAlgorithm/Index';
import CallCenterDashboard from '@/components/dashboards/CallCenter';
import PasswordDue from '@/components/login/PasswordDue';
import ChangePassword from '@/components/login/ChangePassword';
import VpnDisconnected from '@/components/Vpn/VpnDisconnected';
import Home from '@/components/Home/Home';
import WhatsappTemplates from '@/components/WhatsappTemplates/Index';
import Surveys from '@/components/Surveys/Index';
import store from '@/store';

const validatePermissions = (to, next) => {
  const permissionsRoute = to.meta.permissions || [];
  const { role, permissions = [] } = Vue.auth.user() || {};
  let isAcceptable = false;
  isAcceptable = permissions.some(permission => permissionsRoute.includes(permission));
  if (role === 'admin') {
    isAcceptable = true;
  }
  if (to.matched.some(record => record.meta.permissions)) {
    if (!permissionsRoute || (permissionsRoute && !permissionsRoute.length) || isAcceptable) {
      next();
    } else {
      Vue.router.push({ name: 'home' });
    }
  } else {
    next();
  }
};

const routes = [
  {
    path: '/',
    redirect: 'login',
  },
  // Login
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      axios
        .get('httpstatus')
        .then(() => {
          if (Vue.auth.check()) {
            // Vue.router.push(`/${Vue.auth.user().role === 'agent' ? 'chat_center' : 'calls_lists'}`);
            Vue.router.push({ name: 'home' });
          } else {
            next();
          }
        });
    },
  },
  // First Login
  {
    path: '/first_login',
    name: 'FirstLogin',
    component: FirstLogin,
    meta: {
      auth: true,
      permissions: [
      ],
    },
    beforeEnter: (to, from, next) => {
      if (Vue.auth.user().status !== 'pendiente') {
        // Vue.router.push(`/${Vue.auth.user().role === 'agent' ? 'chat_center' : 'calls_lists'}`);
        Vue.router.push({ name: 'home' });
      } else {
        next();
      }
    },
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/recover_password',
    name: 'RecoverPassword',
    component: RecoverPassword,
  },
  {
    path: '/nexus_email',
    name: 'NexusEmail',
    component: NexusEmail,
    meta: {
      auth: true,
      permissions: [
      ],
    },
    beforeEnter: (to, from, next) => {
      if (
        Vue.auth.user().nexus_email
        || parseInt(Vue.auth.user().company_id, 10) === 8230622
        || parseInt(Vue.auth.user().company_id, 10) === 17322821519
      ) {
        // Vue.router.push(`/${Vue.auth.user().role === 'agent' ? 'chat_center' : 'calls_lists'}`);
        Vue.router.push({ name: 'home' });
      } else {
        next();
      }
    },
  },
  {
    path: '/verification-code',
    name: 'verificationCode',
    component: VerificationCode,
    meta: {
      auth: false,
      permissions: [
      ],
    },
    beforeEnter: (to, from, next) => {
      if (
        ((Vue.auth.user() || {}).nexus_email && localStorage.getItem('verified'))
        || parseInt(Vue.auth.user().company_id, 10) === 8230622
        || parseInt(Vue.auth.user().company_id, 10) === 17322821519
      ) {
        Vue.router.push({ name: 'home' });
      } else {
        next();
      }
    },
  },
  // Panel
  // {
  //   path: '/panel',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'Panel',
  //   component: PanelV2,
  // },
  // PanelV2
  // {
  //   path: '/panel_v2',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'PanelV2',
  //   component: Panel,
  // },
  // Reports
  // {
  //   path: '/reports/call_center',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'ReportCallCenter',
  //   component: ReportCallCenter,
  // },
  // {
  //   path: '/reports/notification_schedule',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'Maintenance',
  //   component: Maintenance,
  // },
  // {
  //   path: '/reports/notification_schedules',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'ReportNotificationSchedules',
  //   component: ReportNotificationSchedules,
  // },
  // {
  //   path: '/reports/invoice',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'Consumption',
  //   component: Consumption,
  // },
  // {
  //   path: '/reports/segmentation',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'Segmentation',
  //   component: Segmentation,
  // },
  // {
  //   path: '/reports/product',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'ProductReport',
  //   component: ProductReport,
  // },
  // {
  //   path: '/reports/load',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'ReportLoad',
  //   component: ReportLoad,
  // },
  // {
  //   path: '/reports/customers',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'ReportCustomer',
  //   component: ReportCustomer,
  // },
  // Customers
  {
    path: '/customers',
    meta: {
      auth: true,
      permissions: [
        'see_customers',
      ],
    },
    name: 'Customers',
    component: Customers,
  },
  {
    path: '/customers/:customer/show',
    meta: {
      auth: true,
      permissions: [
        'see_call_center',
        'see_chat_center',
        'see_customers',
        'see_customer_tracking',
      ],
    },
    beforeEnter: (to, from, next) => {
      if (store.state.dialer.callCenterStatus === 3) {
        next();
      } else {
        validatePermissions(to, next);
      }
    },
    name: 'CustomerShow',
    component: CustomerShow,
  },
  {
    path: '/validate/customers/name',
    meta: {
      auth: true,
      permissions: [
        'see_customers',
      ],
    },
    name: 'ValidateCustomerName',
    component: ValidateCustomerName,
  },
  // Chat center
  {
    path: '/chat_center_v2',
    meta: {
      auth: true,
      permissions: [
        'see_chat_center',
      ],
    },
    name: 'ChatCenter',
    component: ChatCenter,
  },
  // {
  //   path: '/config/chat_center',
  //   meta: {
  //     auth: true,
  //     permissions: [
  //       'see_chat_center',
  //     ],
  //   },
  //   name: 'ChatCenterConfig',
  //   component: ChatCenterConfig,
  // },
  {
    path: '/chat_center',
    component: ChatCenterV2Panel,
    children: [
      {
        path: '',
        name: 'ChatCenterV2',
        component: ChatCenterV2,
        meta: {
          permissions: [
            'see_chat_center',
          ],
        },
      },
      {
        path: 'inbox',
        name: 'ChatCenterV2Inbox',
        component: ChatCenterV2,
        meta: {
          permissions: [
            'see_chat_center',
          ],
        },
      },
      {
        path: 'config',
        name: 'ChatCenterV2Config',
        component: ChatCenterV2Config,
        meta: {
          permissions: [
            'see_chat_center',
          ],
        },
      },
      {
        path: 'dashboard',
        name: 'ChatCenterReportV2',
        component: ChatCenterReportV2,
        meta: {
          permissions: [
            'see_chat_center',
          ],
        },
      },
    ],
    meta: {
      auth: true,
      permissions: [
        'see_chat_center',
      ],
    },
  },
  // Templates
  {
    path: '/campaigns/templates',
    meta: {
      auth: true,
      permissions: [
        'create_templates',
        'see_templates',
        'edit_templates',
        'delete_templates',
      ],
    },
    name: 'Templates',
    component: Templates,
  },
  {
    path: '/config/templatesV2/bot/:botTemplate',
    meta: {
      auth: true,
      permissions: [ // no se encontro permiso
      ],
    },
    name: 'BotWorkflowV2',
    component: BotWorkflowV2,
  },
  // Notification Schedules
  {
    path: '/notification_schedules',
    meta: {
      auth: true,
      permissions: [
        'see_daily_managements',
      ],
    },
    name: 'NotificationSchedule',
    component: NotificationSchedule,
  },
  // Company Emails
  {
    path: '/company_emails',
    meta: {
      auth: true,
      permissions: [
        'create_company_emails',
        'see_company_emails',
        'edit_company_emails',
        'delete_company_emails',
      ],
    },
    name: 'CompanyEmails',
    component: CompanyEmails,
  },
  // Users
  {
    path: '/users',
    meta: {
      auth: true,
      permissions: [
        'create_users',
        'see_users',
        'edit_users',
        'delete_users',
      ],
    },
    name: 'User',
    component: User,
  },
  // Campaigns
  {
    path: '/campaigns',
    meta: {
      auth: true,
      permissions: [
        'see_campaigns',
        'create_campaigns',
      ],
    },
    name: 'Campaign',
    component: Campaign,
  },
  {
    path: '/campaigns/:campaign/confirm',
    meta: {
      auth: true,
      permissions: [
        'see_campaigns',
      ],
    },
    name: 'CampaignConfirm',
    component: CampaignConfirm,
  },
  {
    path: '/campaigns/:campaign/resend',
    meta: {
      auth: true,
      permissions: [
        'see_campaigns',
      ],
    },
    name: 'CampaignResend',
    component: CampaignResend,
  },
  {
    path: '/campaigns/:campaign/detail',
    meta: {
      auth: true,
      permissions: [
        'see_campaigns',
      ],
    },
    name: 'CampaignDetail',
    component: CampaignDetail,
  },
  {
    path: '/campaigns/:campaign/assigned',
    meta: {
      auth: true,
      permissions: [
        'see_campaigns',
      ],
    },
    name: 'CampaignAssigned',
    component: CampaignAssigned,
  },
  // Invalid data
  {
    path: '/invalid_data',
    meta: {
      auth: true,
      permissions: [
        'see_invalid_data',
      ],
    },
    name: 'InvalidData',
    component: InvalidData,
  },
  // Answer Template
  {
    path: '/config/answer_templates',
    meta: {
      auth: true,
      permissions: [
        'create_answer_templates',
        'see_answer_templates',
        'edit_answer_templates',
        'delete_answer_templates',
      ],
    },
    name: 'AnswerTemplate',
    component: AnswerTemplate,
  },
  // Workflow Channel
  {
    path: '/workflow_channels',
    meta: {
      auth: true,
      permissions: [
        'create_workflow_channels',
        'see_workflow_channels',
        'edit_workflow_channels',
        'delete_workflow_channels',
      ],
    },
    name: 'WorkflowChannel',
    component: WorkflowChannel,
  },
  // Workflow Notifications
  {
    path: '/workflow_notifications',
    meta: {
      auth: true,
      permissions: [
        'create_workflow_notifications',
        'see_workflow_notifications',
        'edit_workflow_notifications',
        'delete_workflow_notifications',
      ],
    },
    name: 'WorkflowNotification',
    component: WorkflowNotification,
  },
  {
    path: '/workflow_notifications/:workflowNotification/stages',
    meta: {
      auth: true,
      permissions: [
        'create_workflow_notifications',
        'see_workflow_notifications',
        'edit_workflow_notifications',
        'delete_workflow_notifications',
      ],
    },
    name: 'WorkflowStages',
    component: WorkflowStages,
  },
  // Chat categories
  {
    path: '/chat_categories',
    meta: {
      auth: true,
      permissions: [
        'create_chat_categories',
        'see_chat_categories',
        'edit_chat_categories',
        'delete_chat_categories',
      ],
    },
    name: 'ChatCategories',
    component: ChatCategories,
  },
  // Call center
  /*
  {
    path: '/call_center/dialer',
    meta: {
      auth: true,
    },
    name: 'CallCenterDialer',
    component: CallCenterDialer,
  },
  {
    path: '/call_center/single',
    meta: {
      auth: true,
    },
    name: 'CallCenterSingle',
    component: CallCenterSingle,
  },
  */
  // Call center V2
  {
    path: '/calls_lists',
    meta: {
      auth: true,
      permissions: [
        'see_call_center',
      ],
    },
    name: 'CallList',
    component: CallList,
  },
  {
    path: '/call_center/connect',
    meta: {
      auth: true,
      permissions: [
        'see_call_center',
      ],
    },
    name: 'ConnectCampaign',
    component: ConnectCampaign,
  },
  {
    path: '/calls_lists/wait',
    meta: {
      auth: true,
      permissions: [
        'see_call_center',
      ],
    },
    name: 'CallListWait',
    component: CallListWait,
  },
  {
    path: '/call_center/wait_v2',
    meta: {
      auth: true,
      permissions: [
        'see_call_center',
      ],
    },
    name: 'CallCenterWaitV2',
    component: CallCenterWaitV2,
  },
  {
    path: '/call_center/users',
    meta: {
      auth: true,
      permissions: [
        'see_call_center_operators',
      ],
    },
    name: 'CallCenterUsers',
    component: CallCenterUsers,
  },
  {
    path: '/numx/call_center/algorithm',
    name: 'NumxCallCenterAlgorithm',
    component: NumxCallCenterAlgorithm,
    meta: {
      auth: true,
      permissions: [
        'numx_see_call_center_algorithm',
      ],
    },
    beforeEnter: (to, from, next) => {
      const user = Vue.auth.user();
      // if (parseInt(user.company_id, 10) !== 26521363) {
      //   Vue.router.push({ name: 'home' });
      //   return;
      // }
      validatePermissions(to, next);
    },
  },
  // {
  //   path: '/calls_lists/:callList',
  //   meta: {
  //     auth: true,
  //     permissions: [
  //       'see_call_center',
  //     ],
  //   },
  //   name: 'CallListDetail',
  //   component: CallListDetail,
  // },
  // Report Downloads
  {
    path: '/report_downloads',
    meta: {
      auth: true,
      permissions: [
        'create_report_downloads',
        'see_report_downloads',
      ],
    },
    name: 'ReportDownload',
    component: ReportDownload,
  },
  // Domains
  {
    path: '/domains',
    meta: {
      auth: true,
      permissions: [
        'create_domains',
        'see_domains',
        'edit_domains',
        'delete_domains',
      ],
    },
    name: 'Domain',
    component: Domain,
  },
  {
    path: '/homologation',
    meta: {
      auth: true,
      permissions: [
        'see_company_status',
        'edit_company_status',
      ],
    },
    name: 'Homologations',
    component: Homologations,
  },
  // Bot V4
  {
    path: '/bot_v4',
    meta: {
      auth: true,
      permissions: [
        'create_templates',
        'see_templates',
        'edit_templates',
        'delete_templates',
      ],
    },
    name: 'BotV4Index',
    component: BotV4Index,
  },
  {
    path: '/bot_v4/detail/:botTemplate',
    meta: {
      auth: true,
      permissions: [
        'see_templates',
      ],
    },
    name: 'BotV4Flow',
    component: BotV4Flow,
  },
  {
    path: '/ivr_v2',
    meta: {
      auth: true,
      permissions: [
        'create_templates',
        'see_templates',
        'edit_templates',
        'delete_templates',
      ],
    },
    name: 'IvrV4Index',
    component: IvrV4Index,
  },
  {
    path: '/ivr_v2/detail/:ivrTemplate',
    meta: {
      auth: true,
      permissions: [
        'see_templates',
      ],
    },
    name: 'IvrV4Flow',
    component: IvrV4Flow,
  },
  {
    path: '/flows',
    meta: {
      auth: true,
      permissions: [
        'create_workflow_notifications',
        'see_workflow_notifications',
        'edit_workflow_notifications',
        'delete_workflow_notifications',
      ],
    },
    name: 'CollectWorkflows',
    component: CollectWorkflows,
  },
  {
    path: '/flows/:workflow',
    meta: {
      auth: true,
      permissions: [
        'create_workflow_notifications',
        'see_workflow_notifications',
        'edit_workflow_notifications',
        'delete_workflow_notifications',
      ],
    },
    name: 'CollectWorkflow',
    component: CollectWorkflow,
  },
  {
    path: '/flows_v2',
    meta: {
      auth: true,
      permissions: [
        'create_workflow_notifications',
        'see_workflow_notifications',
        'edit_workflow_notifications',
        'delete_workflow_notifications',
        'edit_whatsapp_workflow',
      ],
    },
    name: 'V2CollectWorkflows',
    component: V2CollectWorkflows,
  },
  {
    path: '/flows_v2/:workflow',
    meta: {
      auth: true,
      permissions: [
        'create_workflow_notifications',
        'see_workflow_notifications',
        'edit_workflow_notifications',
        'delete_workflow_notifications',
        'edit_whatsapp_workflow',
      ],
    },
    name: 'V2CollectWorkflow',
    component: V2CollectWorkflow,
  },
  {
    path: '/flows_v3',
    meta: {
      auth: true,
      permissions: [
        'create_workflow_notifications',
        'see_workflow_notifications',
        'edit_workflow_notifications',
        'delete_workflow_notifications',
        'edit_whatsapp_workflow',
      ],
    },
    name: 'V3CollectWorkflows',
    component: V3CollectWorkflows,
  },
  {
    path: '/flows_v3/:workflow',
    meta: {
      auth: true,
      permissions: [
        'create_workflow_notifications',
        'see_workflow_notifications',
        'edit_workflow_notifications',
        'delete_workflow_notifications',
        'edit_whatsapp_workflow',
      ],
    },
    name: 'V3CollectWorkflow',
    component: V3CollectWorkflow,
  },
  // self-service
  {
    path: '/self-service/config',
    meta: {
      auth: true,
      permissions: [ // no se encontro permiso
      ],
    },
    name: 'SelfService',
    component: SelfService,
  },
  {
    path: '/config/containment_states',
    meta: {
      auth: true,
      permissions: [
        'see_content_status_config',
        'edit_content_status_config',
      ],
    },
    component: ContainmentStates,
  },
  {
    path: '/dashboards/:id',
    meta: {
      auth: true,
      permissions: [
        'see_quicksight_dashboards',
      ],
    },
    component: CallCenterDashboard,
  },
  {
    path: '/password/due',
    name: 'duePassword',
    meta: {
      auth: true,
      permissions: [
      ],
    },
    component: PasswordDue,
  },
  {
    path: '/password/change',
    name: 'changePassword',
    meta: {
      auth: true,
      permissions: [
      ],
    },
    component: ChangePassword,
  },
  {
    path: '/loading-error',
    name: 'VpnDisconnected',
    component: VpnDisconnected,
    meta: {
      permissions: [
      ],
    },
  },
  {
    path: '/whatsapp_templates',
    name: 'WhatsappTemplates',
    component: WhatsappTemplates,
    meta: {
      auth: true,
      permissions: [
        'see_whatsapp_templates',
        'create_whatsapp_templates',
        'edit_whatsapp_templates',
        'delete_whatsapp_templates',
      ],
    },
  },
  {
    path: '/surveys',
    name: 'Surveys',
    component: Surveys,
    meta: {
      auth: true,
      permissions: [
        'edit_survey',
        'delete_survey',
        'create_survey',
      ],
    },
  },
  // {
  //   path: '/segmentation',
  //   meta: {
  //     auth: true,
  //   },
  //   name: 'Segmentation',
  //   component: Segmentation,
  // },
  {
    path: '/inicio',
    name: 'home',
    component: Home,
    meta: {
      auth: true,
      permissions: [
      ],
    },
  },
  {
    path: '*',
    name: '404',
    beforeEnter: (to, from, next) => {
      next({
        name: 'home',
      });
    },
  },
];

routes.forEach((e) => {
  const routes = [
    'FirstLogin',
    'Login',
    'NexusEmail',
    'verificationCode',
    'changePassword',
    'duePassword',
    'NexusEmail',
    '404',
    'ForgotPassword',
    'RecoverPassword',
  ];
  if (!routes.includes(e.name)) {
    e.beforeEnter = (to, from, next) => {
      const user = Vue.auth.user();
      const roles = [
        'call center DC',
        'chat center DC',
      ];
      const companies = [/*26521363 */ /*, 83806105 */];
      const isRoute = to.name === 'Customers' || to.name === 'CustomerShow' || to.name === 'CustomerV2';
      const hasPermission = user.permissions.includes('see_customer_tracking');
      if (isRoute && companies.includes(user.company_id) && roles.includes(user.role) && !hasPermission) {
        if (store.state.dialer.callCenterStatus === 3 || store.state.dialerV2.status === 3) {
          next();
        } else {
          next({ name: 'home' });
        }
      } else {
        validatePermissions(to, next);
      }
    };
  }
});

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js